var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconGrades(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m456.606 104.394-100-100c-2.813-2.813-6.628-4.394-10.606-4.394h-280c-8.284 0-15 6.716-15 15v482c0 8.284 6.716 15 15 15h380c8.284 0 15-6.716 15-15v-382c0-3.978-1.581-7.793-4.394-10.606zm-95.606-53.181 48.787 48.787h-48.787zm-280 430.787v-452h250v85c0 8.284 6.716 15 15 15h85v352z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m386 420h-120c-8.284 0-15 6.716-15 15s6.716 15 15 15h120c8.284 0 15-6.716 15-15s-6.716-15-15-15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m386 360h-120c-8.284 0-15 6.716-15 15s6.716 15 15 15h120c8.284 0 15-6.716 15-15s-6.716-15-15-15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m276 200h10v10c0 8.284 6.716 15 15 15s15-6.716 15-15v-10h10c8.284 0 15-6.716 15-15s-6.716-15-15-15h-10v-10c0-8.284-6.716-15-15-15s-15 6.716-15 15v10h-10c-8.284 0-15 6.716-15 15s6.716 15 15 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m262.462 289.704-55.813-147.894c-.052-.138-.106-.274-.162-.411-2.85-6.927-9.527-11.399-17.016-11.399h-.02c-7.496.008-14.173 4.496-17.011 11.435-.046.113-.091.226-.134.339l-56.325 147.887c-2.949 7.742.937 16.408 8.679 19.356 1.757.669 3.561.986 5.336.986 6.044 0 11.741-3.681 14.021-9.665l10.348-27.17h69.791l10.238 27.128c2.925 7.751 11.579 11.664 19.33 8.737 7.751-2.924 11.663-11.578 8.738-19.329zm-96.67-46.536 23.63-62.042 23.414 62.042z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGrades);
export default __webpack_public_path__ + "static/media/icon-grades.08503d06.svg";
export { ForwardRef as ReactComponent };